var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:{ selected: _vm.value },on:{"click":_vm.click}},[_c('el-checkbox',{model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }